import { useParams, Link } from 'react-router-dom';
import PanelLayout from '../components/PanelLayout';

export default function ChatPage() {
  const { id } = useParams();

  return (
    <PanelLayout>
      <div className="max-w-3xl mx-auto">
        <div className="mb-4">
          <Link
            to="/terapist-panel/gorusmeler"
            className="text-xs text-dark-teal-500 font-medium hover:underline inline-flex items-center gap-1"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </span>
            Görüşmelerime Dön
          </Link>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 p-8 text-center">
          <span className="w-16 h-16 flex items-center justify-center mx-auto rounded-full bg-gray-50 text-gray-300 mb-4">
            <i className="ri-chat-3-line text-3xl" />
          </span>
          <h2 className="text-lg font-semibold text-deep-navy-500 mb-2">Görüşme #{id}</h2>
          <p className="text-sm text-gray-500 mb-4">
            Chat detay ekranı sonraki aşamada tam olarak geliştirilecektir.
          </p>
          <p className="text-xs text-gray-400">
            Bu ekranda güvenli mesajlaşma, telefon paylaşım onayı ve görüşme durumu yönetimi olacaktır.
          </p>
        </div>
      </div>
    </PanelLayout>
  );
}